import React from "react";

import "./hero-headline.scss";

interface Props {
  alt?: string;
}

/**
 * Page title. The type comes from `hero-headline.scss` — it used to be pinned
 * here with an inline `color: black; font-weight: bold`, which no stylesheet
 * could override, so the page ignored the design system.
 */
const HeroHeadline: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => (
  <h1 className="hero-headline">
    {children}
    <img
      className="hero-headline__mark"
      src={require("../../icons/pointvirgule.png")}
      alt=""
      aria-hidden="true"
    />
  </h1>
);

export default HeroHeadline;
